<template>
    <div class="box">
      <header class="header">
        <img class="img" src="@/static/image/back.png" @click="back" />
        <div class="header_title">订单详情</div>
      </header>
      <div class="bill">
        <div class="bill_info">
          <div class="bill_info_head">
            <span class="bill_info_head_text">单据编号： {{ bill.number }}</span>
          </div>
          <div class="line"></div>
          <div class="bill_info_main">
            <div class="bill_info_item" style="padding-top: 0.32rem;">
              <span class="bill_info_item_text">商品金额： </span>
              <span class="bill_info_item_context">￥{{ bill.goodsSum }}</span>
            </div>
            <div class="bill_info_item">
              <span class="bill_info_item_text">折后金额： </span>
              <span class="bill_info_item_context">￥{{ bill.afterDiscountSum }}</span>
              <span class="bill_info_item_context" style="color: #666666;">{{ bill.discount === 1 ? "" : `（整单折扣${bill.discount * 100}%）` }}</span>
            </div>
            <div class="bill_info_item">
              <span class="bill_info_item_text">税额： </span>
              <span class="bill_info_item_context">￥{{ bill.tax }}</span>
              <span class="bill_info_item_context" style="color: #666666;">{{ `（税率${bill.taxRate * 100}%）` }}</span>
            </div>
            <div class="bill_info_item">
              <span class="bill_info_item_text">运费： </span>
              <span class="bill_info_item_context">￥{{ bill.freight }}</span>
            </div>
            <div class="bill_info_item">
              <span class="bill_info_item_text">优惠金额： </span>
              <span class="bill_info_item_context" style="color: #FF553E;">-￥{{ bill.discounts }}</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="bill_info_main">
            <div class="bill_info_item" style="padding-top: 0.32rem;">
              <span class="bill_info_item_text">其他项目： </span>
              <div style="width: calc(100% - 1.8rem);text-align: right;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;">
                <span class="bill_info_item_context">￥{{ bill.otherItemSum }}</span>
                <span class="bill_info_item_context">
                  （<span v-for="(item, index) in bill.otherItemDetails" :key="index">
                      {{ item.accountName }}{{ index != bill.otherItemDetails.length - 1 ? "、" : "" }}
                    </span>） 
                </span>
              </div>
              
            </div>
          </div>
          <div class="line"></div>
          <div class="bill_info_main">
            <div class="bill_info_item" style="padding-top: 0.32rem;">
              <span class="bill_info_item_text">应付金额： </span>
              <span class="bill_info_item_context">￥{{ bill.payable }}</span>
            </div>
            <div class="bill_info_item">
              <span class="bill_info_item_text">已付金额： </span>
              <span class="bill_info_item_context">￥{{ bill.paid }}</span>
            </div>
          </div>
          <div class="line"></div>
          <div class="bill_info_foot">
            <div class="bill_info_item" style="padding-top: 0.32rem;">
              <span class="bill_info_item_text">制单时间： </span>
              <span class="bill_info_item_context">{{ bill.dateTime }}</span>
            </div>
          </div>
        </div>
        <div class="bill_detail">
          <div class="bill_detail_head">
            <span class="bill_detail_head_text">商品明细</span>
            <span class="bill_detail_head_context">
              共 {{ bill.goodsDetails ? bill.goodsDetails.length : 0 }} 种
            </span>
          </div>
          <div class="line" style="position: relative;top: 1.31rem;"></div>
          <div class="goods">
            <div class="goods_detail" v-for="(item, index) in bill.goodsDetails" :key="index">
              <img class="goods_img" :src="item.goodsPicUrl ? item.goodsPicUrl : require('@/static/image/defaultImage.png')"/>
              <div class="goods_info">
                <span style="height: 0.37rem;line-height: 0.37rem;padding-top: 0.25rem;font-size: 0.37rem;font-family: PingFang SC;font-weight: 500;color: #333333;">
                  {{ item.goodsName }}
                </span>
                <span style="height: 0.32rem;line-height: 0.32rem;padding-top: 0.35rem;font-size: 0.32rem;font-family: PingFang SC;font-weight: 500;color: #666666;">
                  {{ item.goodsStandard }}
                </span>
                
                <div class="goods_value">
                  <span style="font-size: 0.32rem;font-family: PingFang SC;font-weight: 500;color: #FF553E;">
                    ￥
                    <span style="font-size: 0.48rem;">{{ item.price }}</span>                
                  </span>
                  <span style="font-size: 0.32rem;font-family: PingFang SC;font-weight: 500;color: #333333;">
                    x {{ item.quantity }} （{{item.unitName}}）
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="loadding_box" v-show="loading">
        <div class="loadding">
          <img class="logo" src="../static/image/logo.png" alt="" />加载中...
        </div>
      </div>
    </div>
  
</template>

<script>

import { headers } from "@/api/orderdetial.js";
import wxAuth from "../module/wx-auth";

import { getCombineBill } from "../api/orderdetial.js";

export default {
  data() {
    return {
      billId: 0, 
      billType: 0, 
      userInfo: {},
      loading: true,
      bill: {}
    };
  },

  methods: {
    
    // 获取单据详情
    getBill() {  
      let billId = this.billId
      let param = {
        billId: billId,
      };
      getCombineBill(param).then((res) => {
        this.loading = false;
        this.bill = res.data;
      });
    },
    // 返回
    back() {
      let previousRoute = this.$store.getters.getPreviousRoute();
      if(previousRoute) {
        this.$router.back();
      }else {
        let noDecodeCustomerId = wxAuth.getEncodeCustomerId();
        this.$router.push({
          name: "User",
          query: {
            customerId: noDecodeCustomerId
          }
        });
      }      
    },
  },
  
  async created() {
    let query = this.$route.query;
    let billId = query.billId;
    this.billId = billId;
    let billType = query.billType;
    this.billType = billType;

    await wxAuth.auth();
    let noDecodeCustomerId = wxAuth.getEncodeCustomerId();   
    headers.customerId = wxAuth.getDecodeCustomerId();
    let customerIdParam = encodeURIComponent(noDecodeCustomerId);
    window.history.replaceState(
      {},
      "",
      `./#/combineBill?customerId=${customerIdParam}&billId=${billId}&billType=${billType}`
    );
    this.userInfo = wxAuth.getUserInfo();
    this.getBill();
  },
};
</script>

<style lang='scss' scoped>

.goods_value {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  height: 0.48rem;
  line-height: 0.48rem;
  padding-top: 0.87rem;
}

.goods_info {
  width: calc(100% - 2.8rem - 0.27rem - 0.31rem);
  display: flex;
  flex-direction: column;
  padding-right: 0.31rem;
}

.goods_img {
  width: 2.8rem;
  height: 2.8rem;
  border-radius: 0.27rem;
}

.goods_detail {
  display: flex;
  justify-content: space-between;
  padding-top: 0.27rem;
  padding-left: 0.32rem;
  // align-items: center;
}

.goods {
  height: calc(100% - 1.31rem);
  position: relative;
  top: 1.31rem;
  overflow: auto;
}

.bill_detail_head_context {
  font-size: 0.37rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #777777;
  line-height: 1.31rem;
}

.bill_detail_head_text {
  font-size: 0.37rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 1.1rem;
}

.bill_detail_head {
  width: 8.64rem;
  height: 1.31rem;
  padding-left: 0.32rem;
  padding-right: 0.24rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
}

.bill_detail {
  width: 9.2rem;
  height: calc(100% - 8.11rem - 0.27rem * 2);
  margin: 0.27rem 0;
  background: #FFFFFF;
  box-shadow: 0.03rem 0.03rem 0.03rem 0.01rem #EBEBEB;
  border-radius: 0.27rem;
}

.bill_info_item_context {
  font-size: 0.32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #333333;
}

.bill_info_item_text {
  font-size: 0.32rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: #666666;
}

.bill_info_item {
  height: 0.32rem;
  line-height: 0.32rem;
  padding-top: 0.25rem;
  padding-left: 0.32rem;
  display: flex;
}

.bill_info_foot {
  padding-bottom: 0.39rem;
}

.bill_info_main {
  padding-bottom: 0.32rem;
}

.bill_info_head_text {
  font-size: 0.37rem;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
  line-height: 1.31rem;
}

.bill_info_head {
  height: 1.31rem;
  padding-left: 0.32rem;
}

.bill_info{
  width: 9.2rem;
  height: 8.11rem;
  background: #FFFFFF;
  box-shadow: 0.03rem 0.03rem 0.03rem 0.01rem #EBEBEB;
  border-radius: 0.27rem;
}

.line {
  width: 8.56rem;
  height: 0.01rem;
  background: #F0F0F0;
  margin: 0 auto;
}

.bill {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100% - 1.44rem);
  position: relative;
  top: 1.44rem;
}

// 公共部分
.logo {
  width: 1.8rem;
}

.loadding {
  width: 4rem;
  height: 3rem;
  padding: 0.3rem;
  background: #696767;
  color: #fff;
  border-radius: 0.206667rem;
  font-size: 0.5rem;
  text-align: center;
}

.loadding_box {
  width: 100vw;
  height: 100vh;
  position: absolute;
  left: 0;
  top: 0;
  /* background: rgba(0, 0, 0, .2); */
  display: flex;
  justify-content: center;
  align-items: center;
}

.header_title{
   font-size: 0.48rem;
    font-weight: bold;
    color: #FFFFFF; 
}

.img{
    height: 0.55rem;
    position: absolute;
    left: 0.4rem;
}

.header{
    width: 100vw;
    height: 1.173333rem;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #495CE1;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 100;
}

.box{
    width: 100vw;
    min-height: 100vh;
    height: 100vh;
    overflow: visible;
    background-color: #f5f5f5;
}
</style>